import { render } from "./PrizesList.vue?vue&type=template&id=38db9583&scoped=true"
import script from "./PrizesList.vue?vue&type=script&lang=js"
export * from "./PrizesList.vue?vue&type=script&lang=js"

import "./PrizesList.vue?vue&type=style&index=0&id=38db9583&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38db9583"]])

export default __exports__